export enum OverviewPeriodPreset {
  Today = "today",
  ThisWeek = "this_week",
  ThisMonth = "this_month",
  ThisQuarter = "this_quarter",
  ThisYear = "this_year",
  Custom = "custom",
}

export type OverviewPeriodQuery = {
  period?: OverviewPeriodPreset
  from?: string
  to?: string
}

export function isOverviewPeriodPreset(value: string | null | undefined): value is OverviewPeriodPreset {
  if (!value) return false
  return Object.values(OverviewPeriodPreset).includes(value as OverviewPeriodPreset)
}
